module.exports = {"TXTWCL_WEXLL_BE_BACK_SOONX":{"id":"TXTWCL_WEXLL_BE_BACK_SOONX","defaultMessage":"VI ÄR SNART TILLBAKA!"}}